'use client';

import { FloatingPortal } from '@floating-ui/react';
import { useContext } from 'react';

import { PopoverRootContext } from './context/popover-root.context';
import type { PopoverPortalPropsInterface } from './types/popover-portal.types';

/**
 * @since 10.0.0
 */
export const PopoverPortal = (props: PopoverPortalPropsInterface) => {
  const { popover } = useContext(PopoverRootContext);

  if (!popover.isMounted) {
    return null;
  }

  return <FloatingPortal {...props} />;
};

PopoverPortal.displayName = 'Popover.Portal';
